<brightside-web-product-eligibility
  [productCode]="'loan'"
  (successfulSubmit)="submitAction()"
  [showBackbutton]="true">
</brightside-web-product-eligibility>
